import styled from 'styled-components';
import { colors } from '../colors';

interface formLabelProps {
	width?: string;
	floatingLabel?: boolean;
}
const FormLabel = styled.label<formLabelProps>`
	display: inline-block;
	width: 100%;
	margin-bottom: 4px;
	font-size: 14px;
	line-height: 14px;
	box-sizing: border-box;

	color: ${colors.Grey58};
	width: ${({ width }) => width}!important;
	${({ floatingLabel }) =>
		floatingLabel &&
		`position: absolute;
		pointer-events: none;
		left: 20px;
		top: 18px;
		transition: 0.3s ease all;
		color: #545454;
		opacity: 0.5;
		text-align: left;
		font-size: 14px;
		@media screen and (max-width: 767px){
			font-size: 14px;
			left: 15px;
		}
		@supports (-ms-ime-align: auto) {
			top: -6px!important;
		  }
	`}
`;

export default FormLabel;
